import { useEffect, useState } from "react";
import * as commonServices from '../services/website.services';
import { FAQTYPES } from "../../../utils/Constants";
import { capitalizeFirstLetter } from "../../../utils/commonfunction";

const FrequentlyAskedQuestions = () => {

  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    commonServices.FaqList({ type: FAQTYPES.WEBSITE }).then((response) => {
      if (response?.success) {
        setFaqData(response?.data?.list || []);
      }
    }).catch((error) => {
      console.log("error", error);
    });
  }, []);

  return (
    // <main>
    //   <section className="frequently-section banner-scetion-padding">
    //     <div className="container">
    //       <h1 className="heading-1">Frequently Asked Questions</h1>
    //     </div>
    //   </section>

    //   <section className="accordion section-padding">
    //     <div className="container">
    //       <div className="accordion d-flex flex-column gap-3" id="faqAccordion">
    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed b-16 h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q1"
    //             >
    //               How do I book a trip?
    //             </button>
    //           </h2>
    //           <div
    //             id="q1"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance
    //             </div>
    //           </div>
    //         </div>
    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button h5-headline-button  m-0 "
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q2"
    //             >
    //               Can I pay with cryptocurrency?
    //             </button>
    //           </h2>
    //           <div
    //             id="q2"
    //             className="accordion-collapse collapse show"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               Lorem Ipsum is simply dummy text of the printing and
    //               typesetting industry. Lorem Ipsum has been the industry's
    //               standard dummy text ever since the 1500s, when an unknown
    //               printer took a galley of type and scrambled it to make a type
    //               specimen book.Lorem Ipsum is simply dummy text of the printing
    //               and typesetting industry. Lorem Ipsum has been the industry's
    //               standard dummy text ever since the 1500s, when an unknown
    //               printer took a galley of type and scrambled it to make a type
    //               specimen book.Lorem Ipsum is simply dummy text of the printing
    //               and typesetting industry.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q3"
    //             >
    //               How do I apply a coupon or discount code?
    //             </button>
    //           </h2>
    //           <div
    //             id="q3"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q4"
    //             >
    //               Is my payment secure?
    //             </button>
    //           </h2>
    //           <div
    //             id="q4"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q5"
    //             >
    //               How do I know if my booking is confirmed?
    //             </button>
    //           </h2>
    //           <div
    //             id="q5"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q6"
    //             >
    //               What happens if my flight is canceled or delayed?
    //             </button>
    //           </h2>
    //           <div
    //             id="q6"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q7"
    //             >
    //               How do I contact customer support?
    //             </button>
    //           </h2>
    //           <div
    //             id="q7"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>

    //         <div className="accordion-item">
    //           <h2 className="accordion-header">
    //             <button
    //               className="accordion-button collapsed h5-headline-button m-0"
    //               type="button"
    //               data-bs-toggle="collapse"
    //               data-bs-target="#q7"
    //             >
    //               How do I apply a coupon or discount code?
    //             </button>
    //           </h2>
    //           <div
    //             id="q7"
    //             className="accordion-collapse collapse"
    //             data-bs-parent="#faqAccordion"
    //           >
    //             <div className="body-1">
    //               <strong>This is the first item’s accordion body.</strong> It
    //               is shown by default, until the collapse plugin adds the
    //               appropriate classes that we use to style each element. These
    //               classes control the overall appearance, as well as the showing
    //               and hiding via CSS transitions. You can modify any of this
    //               with custom CSS or overriding our default variables. It’s also
    //               worth noting that just about any HTML can go within the though
    //               the transition does limit overflow.
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </section>
    // </main>
    <main>
      <section className="frequently-section banner-scetion-padding">
        <div className="container">
          <h1 className="heading-1">Frequently Asked Questions</h1>
        </div>
      </section>

      <section className="accordion section-padding">
        <div className="container">
          {faqData?.length > 0 ? (
            <div className="accordion d-flex flex-column gap-3" id="faqAccordion">
              {faqData && faqData.length > 0 && faqData.map((faq, index) => (
                <div className="accordion-item" key={faq._id || index}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${index === 0 ? '' : 'collapsed'
                        } h5-headline-button m-0`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#q${index}`}
                    >
                      {capitalizeFirstLetter(faq.question)}
                    </button>
                  </h2>
                  <div
                    id={`q${index}`}
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''
                      }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="body-1">{capitalizeFirstLetter(faq.answer)}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <h4 className="text-muted">No FAQs found at the moment.</h4>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
export default FrequentlyAskedQuestions;
